export enum NavCustomizationSetting {
    AppsHidden = 'NavCustomization.AppsHidden',
    ResourceCenterHidden = 'NavCustomization.ResourceCenterHidden',
}
